module.exports = __webpack_public_path__ + "static/media/Certification-pana 2.7a712332.webp";